<script lang="ts">
  import A from '$lib/components/A.svelte';
  import { getLessonLink } from './getLessonLink';

  export let title: string;
  export let id: string;
  export let isAvailable: boolean;
  export let type: 'lesson' | 'checkpoint';

  $: displayTitle = type === 'checkpoint' ? `Checkpoint: ${title}` : title;
</script>

<div class="flex-grow mr-2">
  {#if isAvailable}
    <h3><A class="text-slate-600 font-medium" href={getLessonLink(id)}>{displayTitle}</A></h3>
  {:else}
    <h3 class="lessonTitleLink">{displayTitle}</h3>
  {/if}
</div>
